module.exports = __webpack_public_path__ + "static/media/B1.153b33d1.jpg";